module.exports = __webpack_public_path__ + "img/BE0872743345.057f14d9.png";